import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import {useNavigate} from 'react-router-dom';
import {URLS} from '../constants/appConstants';
import {Paper} from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import InterestsIcon from '@mui/icons-material/Interests';

const styles = {
  stickToBottom: {position: 'fixed', bottom: 0, left: 0, right: 0},
};

export default function AppBottomNav() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const redirectComp = (url) => {
    navigate(url);
  }

  return (
    <>
      <Paper sx={styles.stickToBottom} elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction label="Home" icon={<HomeIcon/>} onClick={() => redirectComp(URLS.HOME)}/>
          <BottomNavigationAction label="Leaderboard" icon={<WorkspacePremiumIcon/>}
                                  onClick={() => redirectComp(URLS.LEADERBOARD)}/>
          <BottomNavigationAction label="Activities" icon={<InterestsIcon/>}
                                  onClick={() => redirectComp(URLS.ACTIVITIES)}/>
          <BottomNavigationAction label="Profile" icon={<PersonIcon/>} onClick={() => redirectComp(URLS.SETTINGS)}/>
        </BottomNavigation>
      </Paper>
    </>
  );
}
